import { render, staticRenderFns } from "./DownloadRequest.vue?vue&type=template&id=30d3fbbe&scoped=true&"
import script from "./DownloadRequest.vue?vue&type=script&lang=js&"
export * from "./DownloadRequest.vue?vue&type=script&lang=js&"
import style0 from "./DownloadRequest.vue?vue&type=style&index=0&id=30d3fbbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d3fbbe",
  null
  
)

export default component.exports